import { Component, OnInit } from "@angular/core";
import { Observable, takeUntil } from "rxjs";
import { FilterChangeModel } from "@gtmhub/hub/events";
import { ICollection } from "@webapp/core/core.models";
import { DestroyService } from "@webapp/core/util/services/destroy.service";
import { INavItem, NavItemsSectionBroadcastConfig } from "@webapp/navigation/models/nav-items-list.models";
import { SubNavOption } from "@webapp/navigation/models/sub-nav-options.models";
import { CustomViewsService } from "@webapp/navigation/services/custom-views.service";
import { NavItemsSectionBroadcastConfigFactory } from "../services/nav-items-section-broadcast-config.factory";

@Component({
  selector: "tasks-sub-navigation",
  templateUrl: "./tasks-sub-navigation.component.html",
})
export class TasksSubNavigationComponent implements OnInit {
  public options: SubNavOption[] = [{ label: "my_tasks", state: "gtmhub.tasks", stateOptions: { filterId: null } }];
  public customViews: ICollection<INavItem>;
  public visibleItemsCount = 5;
  public loadingCustomViews$: Observable<boolean>;
  public broadcastConfig: NavItemsSectionBroadcastConfig = this.broadcastConfigFactory.buildDefaultNavItemsSectionBroadcastConfig();

  constructor(private customViewsService: CustomViewsService, private destroy$: DestroyService, private broadcastConfigFactory: NavItemsSectionBroadcastConfigFactory) {}

  public ngOnInit(): void {
    this.loadingCustomViews$ = this.customViewsService.getLoading$().pipe();
    this.customViewsService
      .getCustomViews$()
      .pipe(takeUntil(this.destroy$))
      .subscribe((filters: FilterChangeModel[]) => {
        this.customViews = {
          items: filters.map((hubFilter) => {
            return {
              id: hubFilter.id,
              uxcType: "task",
              title: hubFilter.name,
            };
          }),
          totalCount: filters.length,
        };
      });
  }
}
